module.exports = __webpack_public_path__ + "static/media/report_area.c3d95882.svg";